export default __webpack_public_path__ + "static/media/svg-2.882a2cd5.svg";